import React from 'react';
import {
  REPORTS_WORDING as W, reportStatusLabel, reportFormatCell, reportDateRangeCell, reportNoteCell, reportCreatedCell,
} from '../../domain/reports';
import { useDatePattern } from '../../context/LocaleContext';
import s from './reports.module.css';

// The list of reports that have been run. Every row opens — a report that is
// not ready explains why rather than doing nothing.

// The status pill, the Format column (and why it says what it says) and the
// dashes are `reportStatusLabel`, `reportFormatCell` and the `…Cell` helpers
// in src/domain/reports.js.
function StatusPill({ status }) {
  return <span className={status === 'ready' ? s.pillReady : s.pillPending}>{reportStatusLabel(status)}</span>;
}

// `pdfAvailable` is whether this build serves report PDFs, which decides
// whether the Format column says a PDF came as CSV (#619).
export default function ReportTable({ reports, onOpen, pdfAvailable = false }) {
  // Date Created and the range in the studio's short date, as MMS's list
  // writes `8/1/2026 - 8/31/2026` for a US studio.
  const datePattern = useDatePattern();
  return (
    <div className={s.wrap}>
      <table className={s.table}>
        <thead>
          <tr>
            <th>{W.columnType}</th>
            <th>{W.columnCreated}</th>
            <th>{W.columnFormat}</th>
            <th>{W.columnRange}</th>
            <th>{W.columnNote}</th>
          </tr>
        </thead>
        <tbody>
          {reports.map((r) => (
            <tr key={r.id}>
              <td>
                <button
                  className={r.status === 'ready' ? s.nameButtonReady : s.nameButton}
                  onClick={() => onOpen(r.id)}
                >
                  {r.label}
                </button>{' '}
                <StatusPill status={r.status} />
              </td>
              <td>{reportCreatedCell(r.createdOn, datePattern)}</td>
              <td>{reportFormatCell(r.params?.format, pdfAvailable)}</td>
              <td>{reportDateRangeCell(r.params, datePattern)}</td>
              <td>{reportNoteCell(r.params)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
